import script from "./FivePage.vue?vue&type=script&setup=true&lang=js"
export * from "./FivePage.vue?vue&type=script&setup=true&lang=js"

import "./FivePage.vue?vue&type=style&index=0&id=cd39679e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd39679e"]])

export default __exports__